import { createSelector } from 'reselect'

const getAuth = ({ Auth }) => Auth

export const getIsLogged = createSelector(
  getAuth,
  ({ isLogged }) => isLogged
)